<div class="scrollable-elements">
  <ng-container [ngTemplateOutlet]="customTemplate"></ng-container>
</div>
